import { useQuery } from 'react-query';
import axios from 'axios';

import { apiConfig } from '@constants';

const getLocationSearch = async (searchText = '') => {
  if (searchText.length < 3) {
    return;
  }

  const { data } = await axios.get(
    `${apiConfig.MAPBOX_PLACES_BASE}/${searchText}.json?access_token=${apiConfig.MAPBOX_API_KEY}&country=us`,
  );

  return data?.features;
};

/**
 * This endpoint will return results based on the passed in search text
 */
export const useGetLocationsSearch = (searchText = '') =>
  useQuery(['getLocationSearch', searchText], () => getLocationSearch(searchText));
